<a
  href="/Settings"
  #origin
  mat-icon-button
  id="settingsButton"
  data-cy="settings-button"
>
  <mat-icon>settings</mat-icon>
</a>
